import clsx from 'clsx'
import { Star } from 'lucide-react'
import styles from './Stars.module.scss'

export interface StarsProps {
  value: number
  max?: number
  /** When provided the stars become a radio group the user can click. */
  onChange?: (value: number) => void
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Stars({ value, max = 5, onChange, size = 'sm', className }: StarsProps) {
  const px = size === 'lg' ? 28 : size === 'md' ? 18 : 13
  return (
    <span className={clsx(styles.stars, className)} role={onChange ? 'radiogroup' : 'img'} aria-label={`${value} of ${max} stars`}>
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < Math.round(value)
        const icon = <Star size={px} fill={filled ? 'currentColor' : 'none'} className={clsx(!filled && styles.starOff)} />
        if (!onChange) return <span key={i}>{icon}</span>
        return (
          <button
            key={i}
            type="button"
            className={styles.starBtn}
            role="radio"
            aria-checked={value === i + 1}
            aria-label={`${i + 1} star${i ? 's' : ''}`}
            onClick={() => onChange(i + 1)}
          >
            {icon}
          </button>
        )
      })}
    </span>
  )
}
